import React, { useState } from "react";
import Modal from "react-modal";
import { locationEndpoint } from "../../api/endpoints";
import { useAppSelector } from "../../redux/hooks";
import { useMsal } from "@azure/msal-react";
import { notifications } from "@mantine/notifications";
import { useIssueReportMutation } from "../../redux/slices/api.slice";
import { floorType } from "../../interfaces/groups";
import { useAuthenticator } from "@aws-amplify/ui-react";

function ReportModal({
  modalOpen,
  closeModal,
  reportDesk,
  floor,
  locationName
}: {
  locationName: string;
  modalOpen: boolean;
  floor: floorType | null;
  closeModal: () => void;
  reportDesk: string | null;
}) {
  const [reportDetails, setReportDetails] = useState("");
  const [issueReport] = useIssueReportMutation();
  const [characterCount, setCharacterCount] = useState(0);
  const { user } = useAuthenticator();
  const token = user.getSignInUserSession()?.getIdToken()?.payload;
  const nameSelector = "hardcoded";
  const { accounts } = useMsal();
  function handleReportDetailsChange(
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) {
    setReportDetails(e.target.value);
    setCharacterCount(e.target.value.length);
  }

  async function handleReportSubmit(e: React.ChangeEvent<HTMLFormElement>) {
    e.preventDefault();
    console.log(
      `Submit report for ${reportDesk} at loction "${nameSelector}" with info: ${reportDetails}`
    );
   

const desscriptionDetails = `Location: ${locationName}\nFloor: ${floor?.name}\nDesk number: ${reportDesk}\nDescription of issue: ${reportDetails}`
    let request = {
      location: locationName,
      business_service: "bbdfc9671bccb5901acea7d0b24bcb0e",
      u_symptom: "9d28113d1b9bd1909592646fe54bcbb4",
      short_description: `Issue in Site: ${locationName}, Floor: ${floor.name}, Desk: ${reportDesk}`, 
      description: desscriptionDetails,
      assignment_group: "b34ed37a9788759059bb70771153af66",
      u_capability: "a63cbf0e1bcfd5509592646fe54bcb3d",
      contact_type: "self-service",
     // caller_id: accounts[0]?.username,
      caller_id: token?.given_name || token?.email,
    };
    try {
      const result = await issueReport(request);
      //@ts-ignore
      if (result.data) {
        notifications.show({
          title: "Success",
          message: "Report send successfully",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (err) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }

    // fetch(locationEndpoint, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(request),
    // }).then((res) => console.log(res));

    setReportDetails("");

    closeModal();
  }

  return (
    <Modal
      isOpen={modalOpen}
      contentLabel="Report an issue"
      onRequestClose={closeModal}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
        },
      }}
    >
      <h2>Report a desk availability issue regarding desk {reportDesk}</h2>
      <form onSubmit={handleReportSubmit}>
        <br />
        <label>
          Please provide details about the issue
          <br />
          <textarea
            cols={50}
            rows={5}
            value={reportDetails}
            onChange={handleReportDetailsChange}
          />
          <br />
          <span>{characterCount}/250 characters</span>
        </label>
        <br />
        <br />
        <button type="submit">Submit report</button>
      </form>
    </Modal>
  );
}

export default ReportModal;
